<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import VersionDetail from '@/modules/setting/views/VersionDetail.vue'
import { CSBulkMessageActionTypes, useCSBulkMessageListStore } from '@/modules/cs/stores/cs.list.store.ts'


const router = useRouter()
const csBulkMessageListStore = useCSBulkMessageListStore()


const pageTabs = computed(() => {
  return csBulkMessageListStore.tabs
})
const displayTabContent = computed(() => {
  return csBulkMessageListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return csBulkMessageListStore.tableConfig
})
const filter = computed(() => {
  return csBulkMessageListStore.filter
})
const loading = computed(() => {
  return csBulkMessageListStore.action_type == CSBulkMessageActionTypes.FETCHING
})
const page = computed(() => {
  return csBulkMessageListStore.page
})
const pageSize = computed(() => {
  return csBulkMessageListStore.pageSize
})
const dataSource = computed(() => {
  return csBulkMessageListStore.data
})

const handleChangeTab = (tab: any) => {

  csBulkMessageListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  csBulkMessageListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  csBulkMessageListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  csBulkMessageListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  csBulkMessageListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  csBulkMessageListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  csBulkMessageListStore.newTab({id: item.id, label: `#${item.id} - ${item.version_name}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  csBulkMessageListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await csBulkMessageListStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> csBulkMessageListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountList()
})

onMounted(() => {
  if(csBulkMessageListStore.action_type === CSBulkMessageActionTypes.PENDING) requestFetchAccountList()
})
</script>

<template>
  <dashboard-layout currentRoute="cs/bulk-messages" page-title="Chăm sóc khách hàng - gửi tin hàng loạt" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        primaryField="id"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="csBulkMessageListStore.toggleColumnVisibility"
        @on-row-click="handleRowClick"
        @on-row-dblclick="handleRowDblClick"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"
        :buttons="[
                {
                  label: 'Gửi tin mới',
                  icon: 'bi:send-plus-fill',
                  class: 'btn bg-primary bg-hover-primary text-white',
                  action: () => {
                    router.push({ name: 'account-create' })
                  },
                },
                {
                  label: 'Xoá lịch sử đã chọn',
                  icon: 'tabler:trash',
                  class: 'btn btn-secondary bg-hover-secondary',
                  action: () => {},
                },
              ]"
      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <VersionDetail :id="tab.id" :key="tab.id" action="update"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
